const STATI = {
  // Offerte
  bozza: 'badge-gray',
  inviata: 'badge-blue',
  vinta: 'badge-green',
  persa: 'badge-red',
  scaduta: 'badge-yellow',
  // Commesse
  attiva: 'badge-blue',
  completata: 'badge-green',
  sospesa: 'badge-yellow',
  annullata: 'badge-red',
  // Fatturazioni
  da_emettere: 'badge-gray',
  emessa: 'badge-blue',
  pagata: 'badge-green',
  // Offerte consulenti
  chiusa: 'badge-purple',
};

const LABELS = {
  bozza: 'Bozza', inviata: 'Inviata', vinta: 'Vinta', persa: 'Persa', scaduta: 'Scaduta',
  attiva: 'Attiva', completata: 'Completata', sospesa: 'Sospesa', annullata: 'Annullata',
  da_emettere: 'Da emettere', emessa: 'Emessa', pagata: 'Pagata', chiusa: 'Chiusa',
};

export default function StatusBadge({ stato }) {
  return (
    <span className={STATI[stato] || 'badge-gray'}>
      {LABELS[stato] || stato}
    </span>
  );
}
